export default function PitchTypeToPitchName(pitchType) {
    if (pitchType === 'FT') return '2-Seam Fastball'
    if (pitchType === 'FF') return '4-Seam Fastball'
    if (pitchType === 'AB') return 'Automatic Ball'
    if (pitchType === 'CH') return 'Changeup'
    if (pitchType === 'CS') return 'Curveball'
    if (pitchType === 'CU') return 'Curveball'
    if (pitchType === 'FC') return 'Cutter'
    if (pitchType === 'EP') return 'Eephus'
    if (pitchType === 'FA') return 'Fastball'
    if (pitchType === 'FO') return 'Forkball'
    if (pitchType === 'IN') return 'Intentional Ball'
    if (pitchType === 'KC') return 'Knuckle Curve'
    if (pitchType === 'KN') return 'Knuckleball'
    if (pitchType === 'PO') return 'Pitch Out'
    if (pitchType === 'SC') return 'Screwball'
    if (pitchType === 'SI') return 'Sinker'
    if (pitchType === 'SL') return 'Slider'
    if (pitchType === 'ST') return 'Sweeper'
    if (pitchType === 'SV') return 'Slurve'
    if (pitchType === 'FS') return 'Split-Finger'
    if (pitchType === 'UN') return 'Unknown'
    return ''
}
